import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import PUBGMAN from '../../../../app/assets/images/projectImage/quivverImages/pubgman.webp'

const QuivverObjective = () => {
    // Create ref for scroll-triggered animation
    const componentRef = useRef(null);
    const titleRef = useRef(null);

    // Use inView hook for scroll animation trigger - works on scroll up and down
    const isComponentInView = useInView(componentRef, { once: false, amount: 0.2 });
    const isTitleInView = useInView(titleRef, { once: false, amount: 0.3 });

    // Animation variants
    const titleVariant = {
        hidden: { opacity: 0, y: -50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const contentVariant = {
        hidden: { opacity: 0, x: -80 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const imageVariant = {
        hidden: { opacity: 0, x: 80 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut", delay: 0.3 } }
    };

    return (
        <div className='px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 2xl:px-40'>
            <div ref={titleRef}>
                <motion.h2
                    className="uppercase font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-[#2DEE9A] mb-6 sm:mb-8 md:mb-12 lg:mb-16 xl:mb-20"
                    variants={titleVariant}
                    initial="hidden"
                    animate={isTitleInView ? "visible" : "hidden"}
                >
                    Objective
                </motion.h2>
            </div>
            <div className='min-h-[16rem] sm:min-h-[18rem] md:h-[22rem] lg:h-[24rem]' ref={componentRef}>
                <div className='bg-[#51C5FF] flex flex-col md:flex-row w-full'>
                    <motion.div
                        className='p-4 sm:p-6 md:p-8 flex flex-col justify-center w-full md:w-[70%] gap-2 sm:gap-3 md:gap-4'
                        variants={contentVariant}
                        initial="hidden"
                        animate={isComponentInView ? "visible" : "hidden"}
                    >
                        <div className='text-darkGreyPrimary text-sm sm:text-base md:text-xl lg:text-2xl leading-relaxed'>
                            To create a unified ecosystem where gamers can easily
                            find tournaments, connect with other players, track
                            performance, and compete in their favorite games
                        </div>
                        <div className='text-black font-semibold text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed'>— all within a fast, secure, and engaging
                            platform.</div>
                    </motion.div>
                    <motion.div
                        className='w-full md:w-[50%] hidden md:flex justify-center md:-mt-24 lg:-mt-28 xl:-mt-32'
                        variants={imageVariant}
                        initial="hidden"
                        animate={isComponentInView ? "visible" : "hidden"}
                    >
                        <img src={PUBGMAN} className='w-[50%] md:w-[60%] lg:w-[70%] object-contain' alt="PUBG Man" />
                    </motion.div>
                </div>
            </div>
        </div>

    )
}

export default QuivverObjective
